import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from 'jwt-decode';

const Items = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // New state for search term
  const [searchItemName, setSearchItemName] = useState('');


  const token = localStorage.getItem("token")
      const decodedToken = jwtDecode(token);
  
      const username = decodedToken.username;
   const mydb = username.slice(0, 3);
  
  
  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch('/items?mydb=' + mydb);
      if (!response.ok) {
        throw new Error('Failed to fetch items');
      }
      const data = await response.json();
      // Sort items by item_id descending
      const sortedData = data.sort((a, b) => b.id - a.id);
      setItems(sortedData);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const openDeleteModal = (itemId) => {
    setItemToDelete(itemId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setItemToDelete(null);
    setShowDeleteModal(false);
  };

  const handleDelete = async () => {
    if (!itemToDelete) return;
    try {
      const response = await fetch(`/items/${itemToDelete}?mydb=` + mydb, {
        method: 'DELETE',
      });
      if (response.ok) {
        // Update the table by filtering out the deleted item
        setItems(items.filter(item => item.item_id !== itemToDelete));
        toast.success('Item deleted successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        throw new Error('Failed to delete item');
      }
    } catch (err) {
      console.error('Error deleting item:', err);
      alert('Failed to delete item');
    } finally {
      closeDeleteModal();
    }
  };

  const handleEdit = (item) => {
    // Populate form with item data
    setFormData({
      item_id: item.item_id || '',
      item_name: item.item_name || '',
      item_description: item.item_description || '',
      item_feature: item.item_feature || '',
      photo_url: item.photo_url || '',
      photo_url2: item.photo_url2 || '',
      photo_url3: item.photo_url3 || '',
      photo_url4: item.photo_url4 || '',
      photo_url5: item.photo_url5 || '',
      photo_url6: item.photo_url6 || '',
      photo_url7: item.photo_url7 || '',
      cost_price: item.cost_price || '0',
      quantity: item.quantity || '0',
      sell_price: item.sell_price || '0',
      category: item.category || '',
      item_link: item.item_link || '',
      note: item.note || '',
      brand: item.brand || '',
      warrenty: item.warrenty || '', // Using 'warrenty' to match DB field
      item_condition: item.item_condition || '', // Using 'item_condition' to match DB field
      currency: item.currency || 'dollar',
      old_price: item.old_price || '0',
      sale: item.sale || '0',
      featured: item.featured || 'yes',
    });
    
    // Set edit mode and item ID
    setIsEditMode(true);
    setEditingItemId(item.item_id);
    
    // Expand the form and scroll to it
    setIsExpanded(true);
    setTimeout(() => {
      document.getElementById('itemForm').scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleCopy = (item) => {
    // Populate form with item data but clear item_id
    setFormData({
      item_id: '',
      item_name: item.item_name || '',
      item_description: item.item_description || '',
      item_feature: item.item_feature || '',
      photo_url: item.photo_url || '',
      photo_url2: item.photo_url2 || '',
      photo_url3: item.photo_url3 || '',
      photo_url4: item.photo_url4 || '',
      photo_url5: item.photo_url5 || '',
      photo_url6: item.photo_url6 || '',
      photo_url7: item.photo_url7 || '',
      cost_price: item.cost_price || '0',
      quantity: item.quantity || '0',
      sell_price: item.sell_price || '0',
      category: item.category || '',
      item_link: item.item_link || '',
      note: item.note || '',
      brand: item.brand || '',
      warrenty: item.warrenty || '',
      item_condition: item.item_condition || '',
      currency: item.currency || 'dollar',
      old_price: item.old_price || '0',
      sale: item.sale || '0',
      featured: item.featured || 'yes',
    });
    // Set add mode (not edit)
    setIsEditMode(false);
    setEditingItemId(null);
    // Expand the form and scroll to it
    setIsExpanded(true);
    setTimeout(() => {
      document.getElementById('itemForm').scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };
  const [formData, setFormData] = useState({
    item_id: '',
    item_name: '',
    item_description: '',
    item_feature: '',
    photo_url: '',
    photo_url2: '',
    photo_url3: '',
    photo_url4: '',
    photo_url5: '',
    photo_url6: '',
    photo_url7: '',
    cost_price: '0',
    quantity: '0',
    sell_price: '0',
    category: '',
    item_link: '',
    note: '',
                  brand: '',
                  warrenty: '',
                  item_condition: '',
    currency: 'dollar',
    old_price: '0',
    sale: '0',
    featured: 'yes',
  });

  const [loadingPhotos, setLoadingPhotos] = useState({
    photo_url: false,
    photo_url2: false,
    photo_url3: false,
    photo_url4: false,
    photo_url5: false,
    photo_url6: false,
    photo_url7: false,
  });

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // New handler for file input change for photo_url1
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoadingPhotos(prev => ({ ...prev, photo_url: true }));

    // Compress image before upload
    const compressedFile = await compressImage(file);

    const formDataFile = new FormData();
    formDataFile.append('file', compressedFile);

    try {
      const response = await fetch('/upload?mydb=' + mydb, {
        method: 'POST',
        body: formDataFile,
      });
      if (response.ok) {
        const data = await response.json();
        setFormData(prev => ({
          ...prev,
          photo_url: data.fileUrl,
          photo_url_deletedName: undefined,
        }));
      } else {
        console.error('Upload failed');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingPhotos(prev => ({ ...prev, photo_url: false }));
    }
  };

  // New handlers for file input change for photo_url2 to photo_url7
  const handleFileChangeN = (field) => async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoadingPhotos(prev => ({ ...prev, [field]: true }));

    // Compress image before upload
    const compressedFile = await compressImage(file);

    const formDataFile = new FormData();
    formDataFile.append('file', compressedFile);

    try {
      const response = await fetch('/upload?mydb=' + mydb, {
        method: 'POST',
        body: formDataFile,
      });
      if (response.ok) {
        const data = await response.json();
        setFormData(prev => ({
          ...prev,
          [field]: data.fileUrl,
          [`${field}_deletedName`]: undefined,
        }));
      } else {
        console.error('Upload failed');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingPhotos(prev => ({ ...prev, [field]: false }));
    }
  };

  // New helper function to compress image using canvas
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const maxWidth = 800;
        const maxHeight = 800;
        let width = img.width;
        let height = img.height;

        // Calculate new dimensions while maintaining aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height *= maxWidth / width));
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width *= maxHeight / height));
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert canvas to Blob with quality 0.7 (70%)
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              reject(new Error('Compression failed'));
            }
          },
          file.type,
          0.7
        );
      };

      img.onerror = (err) => {
        reject(err);
      };

      reader.onerror = (err) => {
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <a href="/"
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#2980b9';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#3498db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '18px' }}>←</span>
            Home
          </a>

          {/* Search Input */}
          <input
            type="text"
            placeholder="Search by Name, ID, Category, Brand, Description..."
            value={searchItemName}
            onChange={(e) => setSearchItemName(e.target.value)}
            style={{
              padding: '8px 12px',
              border: '1px solid #dce4ec',
              borderRadius: '8px',
              fontSize: '14px',
              width: '300px'
            }}
          />

          {/* Clear Button */}
          {searchItemName && (
            <button
              onClick={() => setSearchItemName('')}
              style={{
                padding: '8px 12px',
                backgroundColor: '#95a5a6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Clear
            </button>
          )}
        </div>
        <div style={{
          backgroundColor: '#27ae60',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Total Items: {items.length}
        </div>
      </div>
      <h1 style={{
        color: '#2c3e50',
        textAlign: 'center',
        marginBottom: '30px',
        fontSize: '2.5rem',
        fontWeight: '300',
        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>Items Management</h1>
      
      <div style={{ 
        backgroundColor: 'white',
        borderRadius: '12px', 
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        marginBottom: '20px'
      }}>
        <button
          onClick={toggleExpand}
          style={{
            width: '100%',
            padding: '20px',
            backgroundColor: isExpanded ? '#3498db' : '#34495e',
            border: 'none',
            textAlign: 'left',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: '600',
            color: 'white',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
          aria-expanded={isExpanded}
          aria-controls="itemForm"
        >
          <span>Add New Item</span>
          <span style={{ 
            fontSize: '20px',
            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
          }}>▶</span>
        </button>
        {isExpanded && (
          <form id="itemForm" style={{ 
            padding: '30px',
            backgroundColor: '#ffffff'
          }} onSubmit={async (e) => {
            e.preventDefault();
            try {
              const url = isEditMode 
                ? `/items/${editingItemId}?mydb=`+mydb
                : '/items?mydb=' + mydb;
              
              const response = await fetch(url, {
                method: isEditMode ? 'PUT' : 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });
              const data = await response.json();
              
              if (response.ok) {
                toast.success(isEditMode ? 'Item updated successfully' : 'Item created successfully', {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                
                // Reset form data
                setFormData({
                  item_id: '',
                  item_name: '',
                  item_description: '',
                  item_feature: '',
                  photo_url: '',
                  photo_url2: '',
                  photo_url3: '',
                  photo_url4: '',
                  photo_url5: '',
                  photo_url6: '',
                  photo_url7: '',
                  cost_price: '0',
                  quantity: '0',
                  sell_price: '0',
                  category: '',
                  item_link: '',
                  note: '',
                  brand: '',
                      warrenty: '',
                      item_condition: '',
                  currency: 'dollar',
                  old_price: '0',
                  sale: '0',
                  featured: 'yes',
                });
                
                // Reset edit mode
                setIsEditMode(false);
                setEditingItemId(null);
                setIsExpanded(false);
                
                // Refresh the items list to show updated data
                await fetchItems();
              } else {
                // Show specific error message from server if available
                const errorMessage = data.message || (isEditMode ? 'Failed to update item' : 'Failed to create item');
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            } catch (error) {
              console.error('Error submitting form:', error);
              toast.error('Error submitting form: ' + error.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Item ID:</label>
              <input 
                type="number" 
                name="item_id" 
                value={formData.item_id} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none',
                  '&:focus': {
                    borderColor: '#3498db'
                  }
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Item Name:</label>
              <input 
                type="text" 
                name="item_name" 
                value={formData.item_name} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none',
                  '&:focus': {
                    borderColor: '#3498db'
                  }
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Item Description:</label>
              <textarea 
                name="item_description" 
                value={formData.item_description} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  resize: 'vertical',
                  outline: 'none',
                  fontFamily: 'inherit'
                }}
                placeholder="Enter detailed description of the item..."
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Item Features:</label>
              <textarea 
                name="item_feature" 
                value={formData.item_feature} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  resize: 'vertical',
                  outline: 'none',
                  fontFamily: 'inherit'
                }}
                placeholder="List key features and specifications..."
              />
            </div>
            <div style={{ marginBottom: '30px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '15px',
                color: '#2c3e50',
                fontSize: '16px',
                fontWeight: '500'
              }}>Photos:</label>
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                gap: '20px',
                padding: '20px',
                background: '#f8f9fa',
                borderRadius: '12px',
                border: '2px dashed #dee2e6'
              }}>
                {/* Photo Upload 1 */}
                <div>
                  <input
                    type="file"
                    name="photo"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="photo_url_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url}
                          alt="Uploaded preview"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url;
                            document.getElementById('photo_url_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            })
                            .then(response => {
                              if (response.ok) {
                                setFormData(prev => ({ ...prev, photo_url: '', photo_url_deletedName: fileName }));
                                toast.success('Image deleted successfully', {
                                  position: "top-right",
                                  autoClose: 3000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                });
                              } else {
                                throw new Error('Failed to delete image');
                              }
                            })
                            .catch(err => {
                              console.error('Failed to delete image:', err);
                              toast.error('Failed to delete image', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              });
                            });
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
                {/* Photo Upload 2 */}
                <div>
                  <input
                    type="file"
                    name="photo2"
                    onChange={handleFileChangeN('photo_url2')}
                    style={{ display: 'none' }}
                    id="photo_url2_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url2_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url2 ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url2 ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url2}
                          alt="Uploaded preview 2"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url2;
                            document.getElementById('photo_url2_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            }).catch(err => console.error('Failed to delete image:', err));
                            setFormData(prev => ({ ...prev, photo_url2: '', photo_url2_deletedName: fileName }));
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo 2"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
                {/* Photo Upload 3 */}
                <div>
                  <input
                    type="file"
                    name="photo3"
                    onChange={handleFileChangeN('photo_url3')}
                    style={{ display: 'none' }}
                    id="photo_url3_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url3_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url3 ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url3 ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url3}
                          alt="Uploaded preview 3"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url3;
                            document.getElementById('photo_url3_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            }).catch(err => console.error('Failed to delete image:', err));
                            setFormData(prev => ({ ...prev, photo_url3: '', photo_url3_deletedName: fileName }));
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo 3"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
                {/* Photo Upload 4 */}
                <div>
                  <input
                    type="file"
                    name="photo4"
                    onChange={handleFileChangeN('photo_url4')}
                    style={{ display: 'none' }}
                    id="photo_url4_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url4_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url4 ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url4 ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url4}
                          alt="Uploaded preview 4"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url4;
                            document.getElementById('photo_url4_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            }).catch(err => console.error('Failed to delete image:', err));
                            setFormData(prev => ({ ...prev, photo_url4: '', photo_url4_deletedName: fileName }));
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo 4"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
                {/* Photo Upload 5 */}
                <div>
                  <input
                    type="file"
                    name="photo5"
                    onChange={handleFileChangeN('photo_url5')}
                    style={{ display: 'none' }}
                    id="photo_url5_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url5_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url5 ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url5 ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url5}
                          alt="Uploaded preview 5"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url5;
                            document.getElementById('photo_url5_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            }).catch(err => console.error('Failed to delete image:', err));
                            setFormData(prev => ({ ...prev, photo_url5: '', photo_url5_deletedName: fileName }));
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo 5"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
                {/* Photo Upload 6 */}
                <div>
                  <input
                    type="file"
                    name="photo6"
                    onChange={handleFileChangeN('photo_url6')}
                    style={{ display: 'none' }}
                    id="photo_url6_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url6_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url6 ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url6 ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url6}
                          alt="Uploaded preview 6"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url6;
                            document.getElementById('photo_url6_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            }).catch(err => console.error('Failed to delete image:', err));
                            setFormData(prev => ({ ...prev, photo_url6: '', photo_url6_deletedName: fileName }));
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo 6"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
                {/* Photo Upload 7 */}
                <div>
                  <input
                    type="file"
                    name="photo7"
                    onChange={handleFileChangeN('photo_url7')}
                    style={{ display: 'none' }}
                    id="photo_url7_input"
                    accept="image/*"
                  />
                  <label htmlFor="photo_url7_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                    {loadingPhotos.photo_url7 ? (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        position: 'absolute',
                        top: '30px',
                        left: '30px',
                        zIndex: 10,
                      }} />
                    ) : formData.photo_url7 ? (
                      <div style={{ 
                        position: 'relative', 
                        display: 'inline-block',
                        width: '150px',
                        height: '150px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={formData.photo_url7}
                          alt="Uploaded preview 7"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const fileName = formData.photo_url7;
                            document.getElementById('photo_url7_input').value = null;
                            fetch('/delete-image?mydb=' + mydb, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ fileName }),
                            }).catch(err => console.error('Failed to delete image:', err));
                            setFormData(prev => ({ ...prev, photo_url7: '', photo_url7_deletedName: fileName }));
                          }}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(255, 59, 48, 0.9)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            lineHeight: '22px',
                            padding: 0,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            '&:hover': {
                              backgroundColor: '#ff3b30',
                              transform: 'scale(1.1)'
                            }
                          }}
                          aria-label="Delete photo 7"
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <div style={{
                        width: '150px',
                        height: '150px',
                        border: '2px dashed #3498db',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        color: '#3498db',
                        backgroundColor: '#ebf5ff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                        }
                      }}>
                        <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                        <span style={{ fontSize: '14px', color: '#666' }}>Add Photo</span>
                      </div>
                    )}
                  </label>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Cost Price:</label>
              <input 
                type="number" 
                step="0.01" 
                name="cost_price" 
                value={formData.cost_price} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Quantity:</label>
              <input 
                type="number" 
                name="quantity" 
                value={formData.quantity} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Sell Price:</label>
              <input 
                type="number" 
                step="0.01" 
                name="sell_price" 
                value={formData.sell_price} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Category:</label>
              <select 
                name="category" 
                value={formData.category} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              >
                <option value="">Select a category</option>


{mydb === "mtj" && (
                <optgroup label="Laptops">
                                     <option value="laptops">Laptops</option>
                </optgroup> 

)}

{mydb === "atz" && (
  <>
    <optgroup label="Face care">
      <option value="facial wash">Facial wash</option>
      <option value="face mask">Face mask</option>
      <option value="face scrub">Face scrub</option>
      <option value="lip balm">Lip balm</option>
      <option value="facial serum">Facial serum</option>
    </optgroup>

    <optgroup label="Body care">
      <option value="body scrub">Body scrub</option>
      <option value="body oil">Body oil</option>
      <option value="body lotion">Body lotion</option>
      <option value="body splash">Body splash</option>
      <option value="shea butter cream">Shea butter cream</option>
      <option value="shower gel">Shower gel</option>
      <option value="soap">Soap</option>
      <option value="body whitening cream">Body whitening cream</option>
    </optgroup>

    <optgroup label="Hair care">
      <option value="shampoo anti-dandruff">Shampoo anti-dandruff</option>
      <option value="hair oil">Hair oil</option>
      <option value="hair mask">Hair mask</option>
      <option value="hair mist">Hair mist</option>
      <option value="hair serum">Hair serum</option>
    </optgroup>

    <optgroup label="Perfume">
      <option value="perfume for men">Perfume for men</option>
      <option value="perfume for woman">Perfume for woman</option>
    </optgroup>
  </>
)}




                


                 








{/* end categorry */}

               
              </select>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Item Link:</label>
              <input 
                type="text" 
                name="item_link" 
                value={formData.item_link} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
 <div style={{ marginBottom: '20px',display:'none' }}>     
           <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Note:</label>
              <input 
                type="text" 
                name="note" 
                value={formData.note} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Brand:</label>
              <select 
                name="brand" 
                value={formData.brand} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              >



                <option value="" >Select a Brand</option>




                {mydb === "mtj" && (
                <>
                <option value="hp">Hp</option>
                                     <option value="dell">dell</option>
                                     <option value="lenovo">Lenovo</option>
                
                </>
                                     
                

)}

  {mydb === "atz" && (
              <optgroup label="Popular Brands">
                  <option value="A2Z">A2Z</option>
               
                </optgroup>

)}
                


 






    
                             
              </select>
            </div>
 <div style={{ marginBottom: '20px',display:'none' }}>
                <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Warranty:</label>
              <input 
                type="text" 
                name="warrenty" 
                value={formData.warrenty} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              hidden/>
            </div>
            <div style={{ marginBottom: '20px',display:'none' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Condition:</label>
              <select 
                name="item_condition" 
                value={formData.item_condition} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              >
                <option value="new" hidden>Select condition</option>
                <option value="new" hidden>New</option>
               
              </select>
            </div>
 <div style={{ marginBottom: '20px',display:'none' }}>
                <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Currency:</label>
              <select 
                name="currency" 
                value={formData.currency} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              >
                <option value="dollar" selected>USD ($)</option>
                <option value="euro">EUR (€)</option>
                <option value="pound">GBP (£)</option>
                <option value="yen">JPY (¥)</option>
                <option value="cad">CAD ($)</option>
                <option value="aud">AUD ($)</option>
              </select>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Old Price:</label>
              <input 
                type="number" 
                step="0.01" 
                name="old_price" 
                value={formData.old_price} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
                placeholder="Original price (optional)"
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Sale Percentage:</label>
              <input 
                type="number" 
                name="sale" 
                value={formData.sale} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
                placeholder="Discount percentage (optional)"
              />
            </div>
            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Featured:</label>
              <select 
                name="featured" 
                value={formData.featured} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            <div style={{ textAlign: 'center', paddingTop: '20px', borderTop: '1px solid #eee', display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                type="submit"
                style={{
                  padding: '12px 30px',
                  backgroundColor: '#27ae60',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 10px rgba(39, 174, 96, 0.3)',
                  minWidth: '150px'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#229954';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 15px rgba(39, 174, 96, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#27ae60';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 10px rgba(39, 174, 96, 0.3)';
                }}
              >
                {isEditMode ? 'Update Item' : 'Create Item'}
              </button>
              {isEditMode && (
                <button
                  type="button"
                  onClick={() => {
                    // Reset form to initial state
                    setFormData({
                      item_id: '',
                      item_name: '',
                      item_description: '',
                      item_feature: '',
                      photo_url: '',
                      photo_url2: '',
                      photo_url3: '',
                      photo_url4: '',
                      photo_url5: '',
                      photo_url6: '',
                      photo_url7: '',
                      cost_price: '',
                      quantity: '',
                      sell_price: '',
                      category: '',
                      item_link: '',
                      note: '',
                  brand: '',
                  warrenty: '',
                  item_condition: '',
                      currency: 'dollar',
                      old_price: '',
                      sale: '',
                      featured: 'yes',
                    });
                    setIsEditMode(false);
                    setEditingItemId(null);
                  }}
                  style={{
                    padding: '12px 30px',
                    backgroundColor: '#95a5a6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 10px rgba(149, 165, 166, 0.3)',
                    minWidth: '150px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#7f8c8d';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 15px rgba(149, 165, 166, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#95a5a6';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 10px rgba(149, 165, 166, 0.3)';
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        )}
      </div>
      {/* Items Table */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        marginTop: '30px'
      }}>
        <h2 style={{
          padding: '20px',
          margin: '0',
          borderBottom: '1px solid #eee',
          color: '#2c3e50',
          fontSize: '1.5rem'
        }}>Items List</h2>
        
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
        ) : error ? (
          <div style={{ padding: '20px', color: '#e74c3c', textAlign: 'center' }}>{error}</div>
        ) : items.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#7f8c8d' }}>No items found</div>
        ) : (
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '14px',
              minWidth: '700px'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>ID</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Name</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #eee' }}>Actions</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Category</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Price</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {items
                  .filter(item => {
                    const searchTerm = searchItemName.toLowerCase();
                    return (
                      item.item_name.toLowerCase().includes(searchTerm) ||
                      item.item_id.toString().includes(searchTerm) ||
                      (item.item_description && item.item_description.toLowerCase().includes(searchTerm)) ||
                      (item.category && item.category.toLowerCase().includes(searchTerm)) ||
                      (item.brand && item.brand.toLowerCase().includes(searchTerm))
                    );
                  })
                  .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                  .map((item) => (
                  <tr key={item.item_id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{item.item_id}</td>
                    <td style={{ padding: '12px' }}>{item.item_name}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <button
                          onClick={() => handleEdit(item)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#3498db',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#2980b9';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#3498db';
                          }}
                        >
                          Edit
                        </button>
                      <button
                          onClick={() => openDeleteModal(item.item_id)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#e74c3c',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#c0392b';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#e74c3c';
                          }}
                        >
                          Delete
                        </button>
                        <button
                          onClick={() => handleCopy(item)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#f39c12',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#d68910';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#f39c12';
                          }}
                        >
                          Copy
                        </button>
                      </div>
                    </td>
                    <td style={{ padding: '12px' }}>{item.category}</td>
                    <td style={{ padding: '12px' }}>
                      {item.currency === 'dollar' ? '$' : 
                       item.currency === 'euro' ? '€' : 
                       item.currency === 'pound' ? '£' : 
                       item.currency === 'yen' ? '¥' : 
                       item.currency === 'cad' ? 'CAD $' : 
                       item.currency === 'aud' ? 'AUD $' : '$'}
                      {item.sell_price}
                    </td>
                    <td style={{ padding: '12px' }}>{item.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {/* Pagination Controls */}
        {!loading && !error && items.length > 0 && (
          <div style={{ 
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            borderTop: '1px solid #eee'
          }}>
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: '8px 16px',
                backgroundColor: currentPage === 1 ? '#e9ecef' : '#3498db',
                color: currentPage === 1 ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Previous
            </button>
            <span style={{ 
              display: 'flex', 
              alignItems: 'center',
              color: '#2c3e50',
              fontSize: '14px'
            }}>
              Page {currentPage} of {Math.ceil(items.length / itemsPerPage)}
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(items.length / itemsPerPage)))}
              disabled={currentPage >= Math.ceil(items.length / itemsPerPage)}
              style={{
                padding: '8px 16px',
                backgroundColor: currentPage >= Math.ceil(items.length / itemsPerPage) ? '#e9ecef' : '#3498db',
                color: currentPage >= Math.ceil(items.length / itemsPerPage) ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: currentPage >= Math.ceil(items.length / itemsPerPage) ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Next
            </button>
          </div>
        )}
      </div>
    {showDeleteModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <h3 style={{ marginBottom: '20px', color: '#e74c3c' }}>Confirm Delete</h3>
            <p style={{ marginBottom: '30px' }}>Are you sure you want to delete this item?</p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#e74c3c',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#c0392b';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#e74c3c';
                }}
              >
                Delete
              </button>
              <button
                onClick={closeDeleteModal}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#7f8c8d';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#95a5a6';
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Items;
